<ng-container *ngIf="!isMobile; else mobileView">
  <ion-content>
    <div class="sb-sticky">
      <sports-live-navbar
        [hasBackButton]="true"
        [breadcrumbs]="breadcrumbs"
        (close)="close()"
        (setFilterType)="switchVideo()"
        [hideFilterVideoStreaming]="!market?.StreamingEnabled"
        [hideFilterScoreboard]="!market?.StreamingEnabled"
        [isVideoStreamingActive]="showingVideo"
        [isScoreboardActive]="!showingVideo"
      />

      <!-- Video y scoreBoard -->
      <div class="sb-grid-layout" [ngClass]="{'has-two-items': showingVideo}">
        <ng-container *ngIf="match$ | async as match">
          <sb-live-scoreboard-regular
            *ngIf="scoreboardType === SCOREBOARD_TYPE.REGULAR"
            [match]="match"
            class="sb-grid-layout--item"
          />
          <sb-live-scoreboard-sets
            *ngIf="scoreboardType === SCOREBOARD_TYPE.SETS"
            [match]="match"
            class="sb-grid-layout--item"
          />
          <sb-live-scoreboard-baseball
            *ngIf="scoreboardType === SCOREBOARD_TYPE.BASEBALL"
            [match]="match"
            class="sb-grid-layout--item"
          />
        </ng-container>
        <div
          *ngIf="showingVideo"
          id="video-container"
          class="video-container-live-market-desktop sb-grid-layout--item background-color-base"
        ></div>
      </div>

      <!-- Fin Video y scoreBoard -->
      <sb-tabs-categories
        [color]="'regular'"
        [scrollable]="true"
        [isMobile]="isMobile"
        [smallButton]="!isMobile"
        [categories]="categories$ | async"
        [selectedTab]="currentCategory$ | async"
        (selectTab)="changeFilter($event)"
      />
      <sb-betbuilder
        *ngIf="currentCategory$?.value?.CategoryId === betbuilderCatId"
        [cuotaText]="betbuilderCuotaText"
        [messageText]="betbuilderMessageText"
        [errorMessage]="betbuilderErrorMessage"
        [MASelections]="betbuilderSelection"
        [isMobile]="isMobile"
        (placeBetbuilderBet)="sendAddSmartMarketItem()"
        (removeBetbuilderBet)="removeSmartMarketSelections()"
      />
    </div>

    <sb-marquee-betsense
      *ngIf="betsenseData?.length > 0 && currentCategory$?.value?.CategoryId !== betbuilderCatId && globalVars.FEATURES.SPO_betsenseLiveEnabled"
      [betSenseData]="betsenseData"
      (bet)="betSenseBet($event)"
    />

    <ion-list
      class="events-list events-columns-desk m-unset has-no-padding background-color-base"
      *ngIf="liveMarketBets$ as event"
      no-padding
    >
      <ion-grid class="sb-grid-desktop">
        <ion-row>
          <ion-col class="sb-dropdown--container" col-6>
            <ng-container
              *ngFor="let market of event?.Games; trackBy: trackBy; let index = index; let even = even; let odd = odd"
            >
              <!-- West Side -->
              <sb-dropdown
                *ngIf="even"
                [index]="-1"
                [title]="market?.Name"
                [contentType]="market?.DisplayTypeName"
                [mode]="dropdownMode.MARKET_DESKTOP"
                [currentPage]="'live-market'"
              >
                <!-- Header combined markets -->
                <sb-grid-header
                  *ngIf="market?.isCombined || market?.isHandicap"
                  [titleLeft]="market?.teamHome"
                  [titleCenter]="market?.titleCenter"
                  [titleRight]="market?.teamAway"
                  [market]="market"
                />
                <!-- Header Fast Bets -->
                <sb-grid-header
                  *ngIf="!isFastGamesHidden && !market?.isFastGamesHidden"
                  [titleLeft]="market?.teamHome"
                  [titleCenter]="market?.AllSpov.titleCenter"
                  [titleRight]="market?.AllSpov.titleRight"
                  [market]="market"
                  mode="expanded"
                />
                <!-- Normal bets -->
                <sports-grid
                  [separator]="true"
                  mode="expanded"
                  [event]="event"
                  *ngIf="isFastGamesHidden && !market?.isCombined"
                >
                  <sports-group
                    *ngIf="gametypes.indexOf(market?.GameType) === -1"
                    [betType]="market?.DisplayTypeName"
                    id="1"
                    sb-markets
                  >
                    <sports-bet-button
                      *ngFor="let result of market?.GroupResults; let index = index; trackBy: trackBy"
                      [type]="market?.GameType"
                      [typeName]="market?.DisplayTypeName"
                      [game]="result"
                      [results]="market?.GroupResults"
                      [home]="event?.teamHome"
                      [away]="event?.teamAway"
                      [index]="index"
                      (bet)="bet($event, event, market?.Name, '1', getPosition(market?.GroupResults.length, index))"
                      [locked]="result?.Locked"
                      mode="expanded"
                      [sport]="market?.SportHandle"
                      [selected]="checkSelected(result?.NodeId)"
                    />
                  </sports-group>
                  <sports-group
                    *ngIf="gametypes.indexOf(market?.GameType) !== -1"
                    [betType]="market?.DisplayTypeName"
                    sb-markets
                    id="2"
                  >
                    <sports-bet-button-wrapper-column>
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults[0]; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]="market?.GroupResults"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '2')"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        [away]="event?.away"
                        [home]="event?.home"
                        [selected]="checkSelected(result?.NodeId)"
                        bets
                      />
                    </sports-bet-button-wrapper-column>
                    <sports-bet-button-wrapper-column>
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults[1]; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]="market?.GroupResults"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '3')"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        [selected]="checkSelected(result?.NodeId)"
                        [away]="event?.away"
                        [home]="event?.home"
                        bets
                      />
                    </sports-bet-button-wrapper-column>
                    <sports-bet-button-wrapper-column>
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults[2]; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]="market?.GroupResults"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '4')"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                        bets
                      />
                    </sports-bet-button-wrapper-column>
                  </sports-group>
                </sports-grid>
                <!-- Fast Bet -->
                <ng-container class="events-list" *ngIf="!isFastGamesHidden && !market?.isCombined">
                  <sports-grid mode="single" [betType]="market?.DisplayTypeName" [event]="event">
                    <sports-grid-content-single [title]="market?.titleCenter" content />
                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="3">
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults; let index = index"
                        [type]="market?.DisplayTypeName"
                        [typeName]="market?.GameType"
                        [game]="result"
                        [results]=""
                        [home]="event?.teamHome"
                        [away]="event?.teamAway"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '5')"
                        [isCombined]="true"
                        mode="expanded"
                        [locked]="result?.Locked"
                        [betType]="market?.DisplayTypeName"
                        [sport]="market?.SportHandle"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <sports-grid
                    mode="single"
                    [betType]="market?.DisplayTypeName"
                    [event]="event"
                    [hasBets]="!!market?.GroupResults?.length"
                    [separator]="true"
                  >
                    <sports-grid-content-single [title]="market?.teamAway" content />

                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="4">
                      <ports-bet-button
                        *ngFor="let result of market?.combinedResults; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [results]=""
                        [home]="event?.teamHome"
                        [away]="event?.teamAway"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '6')"
                        [isCombined]="true"
                        [locked]="result?.Locked"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                </ng-container>
                <!-- Fast Bet Finish-->

                <!-- Bets Hard -->
                <sports-grid-helper
                  [bottomSpaceI]="true"
                  [bottomSeparatorI]="indexCombinedResults === market?.combinedResults.length - 1"
                  *ngFor="let game of market?.combinedResults; let indexCombinedResults = index"
                >
                  <sports-grid
                    *ngIf="market?.isHardCombined"
                    [mode]="market?.displayMode"
                    [event]="market"
                    [betType]="market?.DisplayTypeName"
                  >
                    <sports-grid-content-single *ngIf="market?.isCombined" [title]="game?.spov?.[0]" content />

                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="5">
                      <sports-bet-button
                        *ngFor="let result of (game?.results)[0]"
                        [type]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]=""
                        (bet)="bet($event, event, market?.Name, '7')"
                        [locked]="result?.Locked"
                        mode="expanded"
                        bets
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <sports-grid-helper *ngIf="market?.isHardCombined" [betweenI]="true" />
                  <sports-grid
                    *ngIf="market?.isHardCombined"
                    [mode]="market?.displayMode"
                    [event]="market"
                    [betType]="market?.DisplayTypeName"
                  >
                    <sports-grid-content-single [title]="game?.spov?.[1]" content />
                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="6">
                      <sports-bet-button
                        *ngFor="let result of (game?.results)[1]"
                        [type]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]=""
                        (bet)="bet($event, event, market?.Name, '8')"
                        mode="expanded"
                        [locked]="result?.Locked"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                        bets
                        [sport]="market?.SportHandle"
                      />
                    </sports-group>
                  </sports-grid>
                  <!-- Bets Easy  -->
                  <sports-grid
                    *ngIf="market?.isSoftCombined"
                    [mode]="market?.displayMode"
                    [event]="market"
                    [betType]="market?.DisplayTypeName"
                  >
                    <sports-grid-content-single [title]="game?.spov" content />
                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="7">
                      <sports-bet-button
                        *ngFor="let result of game?.results; let i = index"
                        [type]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]=""
                        (bet)="bet($event, event, market?.Name, '9', i.toString())"
                        mode="expanded"
                        [locked]="result?.Locked"
                        bets
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <!-- Bets Easy Fin -->
                </sports-grid-helper>
              </sb-dropdown>
            </ng-container>
          </ion-col>

          <ion-col class="sb-dropdown--container" col-6>
            <ng-container
              *ngFor="let market of event?.Games; trackBy: trackBy; let index = index; let even = even; let odd = odd"
            >
              <!-- East Side -->
              <sb-dropdown
                *ngIf="odd"
                [index]="-1"
                [title]="market?.Name"
                [contentType]="market?.DisplayTypeName"
                [mode]="dropdownMode.MARKET_DESKTOP"
                [currentPage]="'live-market'"
              >
                <!-- Header combined markets -->
                <sb-grid-header
                  *ngIf="market?.isCombined || market?.isHandicap"
                  [titleLeft]="market?.teamHome"
                  [titleCenter]="market?.titleCenter"
                  [titleRight]="market?.teamAway"
                  [market]="market"
                />
                <!-- Header Fast Bets -->
                <sb-grid-header
                  *ngIf="!isFastGamesHidden && !market?.isFastGamesHidden"
                  [titleLeft]="market?.teamHome"
                  [titleCenter]="market?.AllSpov.tileCenter"
                  [titleRight]="market?.AllSpov.titleRight"
                  [market]="market"
                  mode="expanded"
                  class="sb-grid-header-single"
                ></sb-grid-header>
                <!-- Header Fast Bets Finish-->

                <!-- Normal Bet -->
                <sports-grid
                  mode="expanded"
                  [event]="event"
                  *ngIf="isFastGamesHidden && !market?.isCombined"
                  [betType]="market?.DisplayTypeName"
                  [separator]="true"
                >
                  <sports-group
                    *ngIf="gametypes.indexOf(market?.GameType) === -1"
                    [betType]="market?.DisplayTypeName"
                    sb-markets
                    id="8"
                  >
                    <sports-bet-button
                      *ngFor="let result of market?.GroupResults; let index = index; trackBy: trackBy"
                      [type]="market?.GameType"
                      [typeName]="market?.DisplayTypeName"
                      [game]="result"
                      [results]="market?.GroupResults"
                      [home]="event?.teamHome"
                      [away]="event?.teamAway"
                      [index]="index"
                      (bet)="bet($event, event, market?.Name, '10', getPosition(market?.GroupResults.length, index))"
                      [locked]="result?.Locked"
                      mode="expanded"
                      [sport]="market?.SportHandle"
                      [selected]="checkSelected(result?.NodeId)"
                    />
                  </sports-group>
                  <sports-group
                    *ngIf="gametypes.indexOf(market?.GameType) !== -1"
                    [betType]="market?.DisplayTypeName"
                    sb-markets
                    id="9"
                  >
                    <sports-bet-button-wrapper-column>
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults[0]; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]="market?.GroupResults"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '11')"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        bets
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-bet-button-wrapper-column>
                    <sports-bet-button-wrapper-column>
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults[1]; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]="market?.GroupResults"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '12')"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                        bets
                      />
                    </sports-bet-button-wrapper-column>
                    <sports-bet-button-wrapper-column>
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults[2]; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]="market?.GroupResults"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '13')"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        bets
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-bet-button-wrapper-column>
                  </sports-group>
                </sports-grid>
                <!-- Fast Bet -->
                <ng-container class="events-list" *ngIf="!isFastGamesHidden && !market?.isCombined">
                  <sports-grid
                    mode="single"
                    [betType]="market?.DisplayTypeName"
                    [event]="event"
                    [hasBets]="!!market?.GroupResults?.length"
                  >
                    <sports-grid-content-single [title]="market?.titleCenter" content />
                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="10">
                      <sports-bet-button
                        *ngFor="let result of market?.GroupResults; let index = index"
                        [type]="market?.DisplayTypeName"
                        [typeName]="market?.GameType"
                        [game]="result"
                        [results]=""
                        [home]="event?.teamHome"
                        [away]="event?.teamAway"
                        [index]="index"
                        (bet)="bet($event, event, market?.Name, '14')"
                        [isCombined]="true"
                        mode="expanded"
                        [locked]="result?.Locked"
                        [sport]="market?.SportHandle"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <sports-grid [separator]="true" mode="single" [betType]="market?.DisplayTypeName" [event]="event">
                    <sports-grid-content-single [title]="market?.teamAway" content />
                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="11">
                      <sports-bet-button
                        *ngFor="let result of market?.combinedResults; let index = index"
                        [type]="market?.GameType"
                        [typeName]="market?.DisplayTypeName"
                        [game]="result"
                        [results]=""
                        [home]="event?.teamHome"
                        [away]="event?.teamAway"
                        [index]="index"
                        (bet)="bet($event, market, market?.Name, '15')"
                        [isCombined]="true"
                        [locked]="result?.Locked"
                        mode="expanded"
                        [sport]="market?.SportHandle"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                </ng-container>
                <!-- Fast Bet Finish-->

                <!-- Bets Hard -->
                <!-- TEMPLATE4 START -->
                <sports-grid-helper
                  [bottomSpaceI]="true"
                  [bottomSeparatorI]="indexCombinedResults === market?.combinedResults.length - 1"
                  *ngFor="let game of market?.combinedResults; let indexCombinedResults = index"
                >
                  <!-- TEMPLATE4 START -->
                  <sports-grid
                    *ngIf="market?.isHardCombined"
                    [mode]="market?.displayMode"
                    [event]="market"
                    [betType]="market?.DisplayTypeName"
                  >
                    <sports-grid-content-single *ngIf="market?.isCombined" [title]="game?.spov?.[0]" content />

                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="12">
                      <sports-bet-button
                        *ngFor="let result of (game?.results)[0]"
                        [type]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]=""
                        (bet)="bet($event, event, market?.Name, '16')"
                        [locked]="result?.Locked"
                        mode="expanded"
                        bets
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <sports-grid-helper *ngIf="market?.isHardCombined" [betweenI]="true" />
                  <sports-grid
                    *ngIf="market?.isHardCombined"
                    [mode]="market?.displayMode"
                    [event]="market"
                    [betType]="market?.DisplayTypeName"
                  >
                    <sports-grid-content-single *ngIf="market?.isCombined" [title]="game?.spov?.[1]" content />

                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="13">
                      <sports-bet-button
                        *ngFor="let result of (game?.results)[1]"
                        [type]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]=""
                        (bet)="bet($event, event, market?.Name, '17')"
                        mode="expanded"
                        [locked]="result?.Locked"
                        bets
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <!-- Bets Easy  -->
                  <sports-grid
                    *ngIf="market?.isSoftCombined"
                    [mode]="market?.displayMode"
                    [event]="market"
                    [betType]="market?.DisplayTypeName"
                  >
                    <sports-grid-content-single [title]="game?.spov" content />

                    <sports-group [betType]="market?.DisplayTypeName" sb-markets id="14">
                      <sports-bet-button
                        *ngFor="let result of game?.results; let i = index"
                        [type]="market?.DisplayTypeName"
                        [game]="result"
                        [isCombined]="market?.isCombined"
                        [results]=""
                        (bet)="bet($event, event, market?.Name, '18', i.toString())"
                        [locked]="result?.Locked"
                        mode="expanded"
                        bets
                        [sport]="market?.SportHandle"
                        [home]="event?.home"
                        [away]="event?.away"
                        [selected]="checkSelected(result?.NodeId)"
                      />
                    </sports-group>
                  </sports-grid>
                  <!-- Bets Easy Fin -->
                  <!-- TEMPLATE4 end -->
                </sports-grid-helper>
                <!-- Combined Bets Fin -->
              </sb-dropdown>
            </ng-container>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-list>

    <codere-footer />
  </ion-content>
</ng-container>

<!-- Mobile -->
<ng-template #mobileView>
  <ion-header>
    <sports-live-navbar
      [hasBackButton]="true"
      [breadcrumbs]="breadcrumbs"
      (close)="close()"
      (setFilterType)="setFilterType($event)"
      [hideFilterSportradar]="hideFilterType(LIVE_MARKET_FILTER_TYPES.SPORTRADAR)"
      [hideFilterVideoStreaming]="hideFilterType(LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING)"
      [hideFilterScoreboard]="hideFilterType(LIVE_MARKET_FILTER_TYPES.SCOREBOARD)"
      [isSportradarActive]="filterTypeSelected(LIVE_MARKET_FILTER_TYPES.SPORTRADAR)"
      [isVideoStreamingActive]="filterTypeSelected(LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING)"
      [isScoreboardActive]="filterTypeSelected(LIVE_MARKET_FILTER_TYPES.SCOREBOARD)"
    />
  </ion-header>
  <ion-content
    (ionScroll)="onScroll($event)"
    #content
    [ngClass]="{'no-scroll': globalVars?.iosScrollHide}"
    scrollEvents="true"
  >
    <div class="sb-sticky sb-sticky-border-bottom">
      <div *ngIf="!!scoreboardType">
        <sb-live-scoreboard-regular
          *ngIf="filterTypeSelected(LIVE_MARKET_FILTER_TYPES.SCOREBOARD) && scoreboardType === SCOREBOARD_TYPE.REGULAR"
          [match]="match$ | async"
        />
        <sb-live-scoreboard-sets
          *ngIf="filterTypeSelected(LIVE_MARKET_FILTER_TYPES.SCOREBOARD) && scoreboardType === SCOREBOARD_TYPE.SETS"
          [match]="match$ | async"
        />
        <sb-live-scoreboard-baseball
          *ngIf="filterTypeSelected(LIVE_MARKET_FILTER_TYPES.SCOREBOARD) && scoreboardType === SCOREBOARD_TYPE.BASEBALL"
          [match]="match$ | async"
        />
      </div>

      <div class="widgets" [hidden]="!filterTypeSelected(LIVE_MARKET_FILTER_TYPES.SPORTRADAR)">
        <div class="sr-widget sr-widget-3" #scoreboardWidgetSIR></div>
        <div class="sr-widget sr-widget-1" #stickyWidgetSIR></div>
        <div class="sr-widget sr-widget-2" #standardWidgetSIR></div>
      </div>
      <div class="widgets" *ngIf="showFormula1()">
        <div class="sr-widget sr-widget-1 mobileF1Widget" #stickyWidgetSIR2></div>
        <div class="sr-widget sr-widget-2" #standardWidgetSIR2></div>
      </div>

      <div
        [hidden]="!filterTypeSelected(LIVE_MARKET_FILTER_TYPES.VIDEO_STREAMING)"
        id="video-container"
        class="video-container-live-market-mobile sb-grid-layout--item background-color-base"
      ></div>
      <sb-tabs-categories
        [color]="'regular'"
        [scrollable]="true"
        [isMobile]="isMobile"
        [smallButton]="!isMobile"
        [categories]="categories$ | async"
        [selectedTab]="currentCategory$ | async"
        (selectTab)="changeFilter($event)"
      />
      <sb-betbuilder
        *ngIf="currentCategory$?.value?.CategoryId === betbuilderCatId"
        [cuotaText]="betbuilderCuotaText"
        [messageText]="betbuilderMessageText"
        [errorMessage]="betbuilderErrorMessage"
        [MASelections]="betbuilderSelection"
        [isMobile]="isMobile"
        (placeBetbuilderBet)="sendAddSmartMarketItem()"
        (removeBetbuilderBet)="removeSmartMarketSelections()"
      />
    </div>

    <sb-marquee-betsense
      *ngIf="betsenseData?.length > 0 && currentCategory$?.value?.CategoryId !== betbuilderCatId && globalVars.FEATURES.SPO_betsenseLiveEnabled"
      [betSenseData]="betsenseData"
      (bet)="betSenseBet($event)"
    />

    <ion-list class="events-list" *ngIf="liveMarketBets$ as event">
      <sb-dropdown
        *ngFor="let market of event?.Games; trackBy: trackBy; let index = index"
        [index]="-1"
        [title]="market?.Name"
        [mode]="market"
        [currentPage]="'live-market'"
      >
        <!-- Header Combined Bets -->
        <sb-grid-header
          *ngIf="(market?.isSoftCombined ||
            market.isHandicap ||
            market.isHardCombined) &&
            isFastGamesHidden"
          [titleLeft]="market?.teamHome"
          [titleCenter]="market?.titleCenter"
          [titleRight]="market?.teamAway"
          [market]="market"
        />
        <!-- Header Fast Bets -->
        <sb-grid-header
          *ngIf="!isFastGamesHidden"
          [titleLeft]="market?.teamHome"
          [titleCenter]="market?.AllSpov.tileCenter"
          [titleRight]="market?.AllSpov.titleRight"
          [mode]="'expanded'"
          [market]="market"
        />
        <!-- Normal Bets-->
        <sports-grid
          mode="expanded"
          [event]="event"
          [hasBets]="!!market?.GroupResults?.length"
          *ngIf="isFastGamesHidden && !market.isCombined"
          [separator]="true"
        >
          <sports-group
            *ngIf="gametypes.indexOf(market?.GameType) === -1"
            [betType]="market?.DisplayTypeName"
            id="15"
            sb-markets
          >
            <span hidden> {{ market | json }} </span>

            <sports-bet-button
              *ngFor="
                  let result of market?.GroupResults;
                  let index = index;
                  trackBy: trackBy
                "
              [type]="market?.GameType"
              [typeName]="market?.DisplayTypeName"
              [game]="result"
              [results]="market?.GroupResults"
              [home]="event?.teamHome"
              [away]="event?.teamAway"
              [index]="index"
              (bet)="bet($event, event, market?.Name, '1')"
              [selected]="checkSelected(result?.NodeId)"
              mode="expanded"
              [locked]="result?.Locked"
              [sport]="market?.SportHandle"
            />
          </sports-group>

          <sports-group
            *ngIf="gametypes.indexOf(market?.GameType) !== -1"
            [betType]="market?.DisplayTypeName"
            sb-markets
            id="16"
          >
            <sports-bet-button-wrapper-column>
              <sports-bet-button
                *ngFor="let result of market?.GroupResults[0]; let index = index"
                [type]="market?.GameType"
                [typeName]="market?.DisplayTypeName"
                [game]="result"
                [isCombined]="market?.isCombined"
                [results]="market?.GroupResults"
                [locked]="result?.Locked"
                [index]="index"
                (bet)="bet($event, event, market?.Name, '2')"
                mode="expanded"
                [sport]="market?.SportHandle"
                bets
                [home]="event?.home"
                [away]="event?.away"
                [selected]="checkSelected(result?.NodeId)"
              />
            </sports-bet-button-wrapper-column>
            <sports-bet-button-wrapper-column>
              <ssports-bet-button
                *ngFor="let result of market?.GroupResults[1]; let index = index"
                [type]="market?.GameType"
                [typeName]="market?.DisplayTypeName"
                [game]="result"
                [isCombined]="market?.isCombined"
                [results]="market?.GroupResults"
                [locked]="result?.Locked"
                [index]="index"
                (bet)="bet($event, event, market?.Name, '3')"
                mode="expanded"
                [sport]="market?.SportHandle"
                bets
                [home]="event?.home"
                [away]="event?.away"
                [selected]="checkSelected(result?.NodeId)"
              />
            </sports-bet-button-wrapper-column>
            <sports-bet-button-wrapper-column>
              <sports-bet-button
                *ngFor="let result of market?.GroupResults[2]; let index = index"
                [type]="market?.GameType"
                [typeName]="market?.DisplayTypeName"
                [game]="result"
                [isCombined]="market?.isCombined"
                [results]="market?.GroupResults"
                [locked]="result?.Locked"
                [index]="index"
                (bet)="bet($event, event, market?.Name, '4')"
                mode="expanded"
                [sport]="market?.SportHandle"
                bets
                [home]="event?.home"
                [away]="event?.away"
                [selected]="checkSelected(result?.NodeId)"
              />
            </sports-bet-button-wrapper-column>
          </sports-group>
        </sports-grid>
        <!-- FastBets-->
        <ng-container class="events-list" *ngIf="!isFastGamesHidden">
          <sports-grid
            id="fast-bets"
            mode="single"
            [betType]="market?.DisplayTypeName"
            [event]="event"
            [hasBets]="!!market?.GroupResults?.length"
          >
            <sports-grid-content-single [title]="market?.titleCenter" content />

            <sports-group [betType]="market?.DisplayTypeName" sb-markets id="17">
              <sports-bet-button
                *ngFor="let result of market?.GroupResults; let index = index"
                [type]="market?.DisplayTypeName"
                [typeName]="market?.GameType"
                [game]="result"
                [results]=""
                [home]="event?.teamHome"
                [away]="event?.teamAway"
                [index]="index"
                (bet)="bet($event, event, market?.Name, '5')"
                [isCombined]="true"
                [selected]="checkSelected(result?.NodeId)"
                mode="expanded"
                [locked]="result?.Locked"
                [sport]="market?.SportHandle"
              />
            </sports-group>
          </sports-grid>
          <sports-grid
            mode="single"
            [betType]="market?.DisplayTypeName"
            [event]="event"
            [hasBets]="!!market?.GroupResults?.length"
            [separator]="true"
          >
            <sports-grid-content-single [title]="market?.teamAway" content />

            <sports-group [betType]="market?.DisplayTypeName" sb-markets id="18">
              <sports-bet-button
                *ngFor="let game of market?.combinedResults; let index = index"
                [type]="market?.GameType"
                [typeName]="market?.DisplayTypeName"
                [game]="game"
                [results]=""
                [home]="event?.teamHome"
                [away]="event?.teamAway"
                [index]="index"
                (bet)="bet($event, event, market?.Name, '6')"
                [isCombined]="true"
                [selected]="checkSelected(game?.NodeId)"
                [locked]="game?.Locked"
                mode="expanded"
                tappable
                [sport]="market?.SportHandle"
              />
            </sports-group>
          </sports-grid>
        </ng-container>
        <!-- Fast Bet Finish-->
        <!-- COMBINED BETS -->
        <sports-grid-helper
          [bottomSpaceI]="true"
          [bottomSeparatorI]="indexCombinedResults === market?.combinedResults.length - 1"
          *ngFor="let game of market?.combinedResults; let indexCombinedResults = index"
        >
          <!-- COMBINED BETS HARD -->
          <sports-grid
            *ngIf="market?.isHardCombined && isFastGamesHidden"
            [mode]="market?.displayMode"
            [event]="market"
            [betType]="market?.DisplayTypeName"
          >
            <sports-grid-content-single *ngIf="market?.isCombined" [title]="game?.spov?.[0]" content />
            <sports-group [betType]="market?.DisplayTypeName" sb-markets id="19">
              <sports-bet-button
                *ngFor="let result of (game?.results)[0]"
                [type]="market?.DisplayTypeName"
                [game]="result"
                [isCombined]="market?.isCombined"
                [results]=""
                (bet)="bet($event, event, market?.Name, '7')"
                [locked]="result?.Locked"
                mode="expanded"
                bets
                tappable
                [sport]="market?.SportHandle"
                [home]="event?.home"
                [away]="event?.away"
                [selected]="checkSelected(result?.NodeId)"
              />
            </sports-group>
          </sports-grid>
          <sports-grid-helper *ngIf="market?.isHardCombined && isFastGamesHidden" [betweenI]="true" />
          <sports-grid
            *ngIf="market?.isHardCombined && isFastGamesHidden"
            [mode]="market?.displayMode"
            [event]="market"
            [betType]="market?.DisplayTypeName"
          >
            <sports-grid-content-single *ngIf="market?.isCombined" [title]="game?.spov?.[1]" content />

            <sports-group id="20" sb-markets [betType]="market?.DisplayTypeName">
              <sports-bet-button
                *ngFor="let result of (game?.results)[1]"
                [type]="market?.DisplayTypeName"
                [game]="result"
                [isCombined]="market?.isCombined"
                [results]=""
                (bet)="bet($event, event, market?.Name, '8')"
                [locked]="result?.Locked"
                mode="expanded"
                bets
                tappable
                [sport]="market?.SportHandle"
                [home]="event?.home"
                [away]="event?.away"
                [selected]="checkSelected(result?.NodeId)"
              />
            </sports-group>
          </sports-grid>

          <!-- COMBINED BETS EASY-->
          <sports-grid
            *ngIf="market?.isSoftCombined && isFastGamesHidden"
            [mode]="market?.displayMode"
            [event]="market"
          >
            <sports-grid-content-single *ngIf="market?.isCombined" [title]="game?.spov" content />

            <sports-group id="21" sb-markets [betType]="market?.DisplayTypeName">
              <sports-bet-button
                *ngFor="let result of game?.results; let i = index"
                [type]="market?.DisplayTypeName"
                [game]="result"
                [isCombined]="market?.isCombined"
                [results]=""
                (bet)="bet($event, event, market?.Name, '9', i.toString())"
                [locked]="result?.Locked"
                mode="expanded"
                bets
                tappable
                [sport]="market?.SportHandle"
                [home]="event?.home"
                [away]="event?.away"
                [selected]="checkSelected(result?.NodeId)"
              />
            </sports-group>
          </sports-grid>
        </sports-grid-helper>
      </sb-dropdown>
    </ion-list>
    <codere-footer />
  </ion-content>
</ng-template>
